import '../css/landing.css';
import main from '../assets/dajiMaharajImg/landingPageDajiMahaImg.jpg';
import { Link } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';


export default function Landing() {

    return (
        <div className="landing">
               
            <span className="left">
                <div className="titles">
                    <div className="caption2">
                        <p>श्रीसद्गुरू वेंकटेश दाजीमहाराज<span> </span> </p>
                    </div>
                    <div className="caption3">
                        <p>महाराष्ट्राच्या संत परंपरेतील
                            रिद्धी-सिद्धी प्राप्त एक वैदिक संत म्हणून श्रीसद्गुरू वेंकटेश
                            दाजीमहाराज यांचा नावलौकिक आहे. पंचक्रोशीत 
                            नाथसंप्रदायातील
                            योगीराज श्रीगंगाजीबापूमहाराज, महंत गैबीबुवा, ऋषीमुनी मार्कंडेय, महंत सदगीर महाराज, सुफी संत हजरत मस्तान शाहवली, लासिना मठाधिपती
                            श्रीगुरुबुध्दी स्वामी इत्यादी संतांच्या मांदियाळीने 
                            " लक्ष्मीवनाचे " माहात्म्य वाढविले. </p>
                    </div>
                    <div className="btns">
                        <button type="button" className="btn btn-outline-info">
                            <Link to="/dajimah" style={{ textDecoration: 'none', color: 'inherit' }}><b>पुढे वाचा</b></Link>
                        </button>
                    </div>
                </div>
            </span>
            <span className="right">
                {/* Lazy load the image */}
                <LazyLoadImage
                    src={main} // Path to your image
                    alt="Daji Maharaj"
                    // effect="blur" // Optional: Adds blur effect while loading
                    height="auto"
                    width="100%"
                />
            </span>
        </div>
    );
}